import React from 'react';
import './bootcamp.css';

const m_learning = () => {
    return (
        <div className="m_learning__wrap">
            <div className="m_learning container">
                {/* <h3 className="m_learning--title">Learn Essential Skills to Kick-start Your Career</h3> */}
                <p className="m_learning--text inner_pages--text">Geekle-Bootcamp is the best way to gain in-demand machine learning skills in the shortest time with minimum investment.</p>
                <p className="m_learning--text inner_pages--text">A truly immersive experience, you will access a range of industry-focused data science topics on a scale not offered elsewhere. Uniquely, you will also gain invaluable insights by networking and connecting with hundreds of data science attendees, world-renowned instructors, industry experts, and dozens of top companies seeking the next wave of talent.</p>
            </div>
        </div>
    );
};

export default m_learning;